module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLight.ef3c777.ttf";